import { render, staticRenderFns } from "./BulkActionsModal.vue?vue&type=template&id=19cea427"
import script from "./BulkActionsModal.vue?vue&type=script&lang=ts"
export * from "./BulkActionsModal.vue?vue&type=script&lang=ts"
import style0 from "./BulkActionsModal.vue?vue&type=style&index=0&id=19cea427&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports